import fetcher from '../fetcher'

import type { Course } from './types'
import config from '../../config'

export const getAllCourses = async (): Promise<Array<Course>> => {
	try {
		const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/courses`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
		console.error(`Error fetching courses: ${error}`)
		throw error
	}
}

export const getBookmarkedCourses = async (): Promise<Array<Course>> => {
	try {
		const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/course/bookmarks`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
		console.error(`Error fetching bookmarked courses: ${error}`)
		throw error
	}
}

export const getCourseById = async ({ id }: { id: string }): Promise<Course | undefined> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/courses/${id}`, { method: 'GET' })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching course by id: ${error}`)
    throw error
  }
}


export const bookmarkCourse = async (_: string[], { arg }: { arg: { courseId: string, saved: boolean } }) => {
	await fetcher(`${config.VITE_ZRIVE_API_URL}/api/activity/course/${arg.courseId}/bookmark`, { method: 'POST', body: JSON.stringify({ saved: arg.saved }) })
}
